var map = {
	"./gmaro1.jpg": 319,
	"./gmaro2.jpg": 576,
	"./gmaro3.jpg": 6909,
	"assets/collections/editorials/GMARO magazine/gmaro1.jpg": 319,
	"assets/collections/editorials/GMARO magazine/gmaro2.jpg": 576,
	"assets/collections/editorials/GMARO magazine/gmaro3.jpg": 6909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9288;